import React from 'react';
import { Container, Card, CardContent, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Page from 'src/components/Page';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: { paddingTop: theme.spacing(6), paddingBottom: theme.spacing(6) },
  card: { padding: theme.spacing(2) },
  header: { fontWeight: 600, marginBottom: theme.spacing(2) },
  backBtn: { marginTop: theme.spacing(3) }
}));

const ExtraWarrantySales = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Page>
      <Container maxWidth="lg" className={classes.root}>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h5" className={classes.header}>
              Extra Warranty Sales
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Ek garanti teklif, fiyatlandırma ve aktivasyon süreçleri burada yapılandırılacaktır.
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              className={classes.backBtn}
              onClick={() => history.push('/Sales')}
            >
              ← Back to Sales
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default ExtraWarrantySales;
